/* tslint:disable */
/* eslint-disable */
export enum CustomLocalizationTarget {
  Frontend = 'frontend',
  Backoffice = 'backoffice',
  Email = 'email',
  Api = 'api'
}
